import { Component, OnInit, Input } from '@angular/core';
import { DndDropEvent, DropEffect } from 'ngx-drag-drop';
import { polyfill } from 'mobile-drag-drop';
import { scrollBehaviourDragImageTranslateOverride } from "mobile-drag-drop/scroll-behaviour";

@Component({
  selector: 'app-item-selection',
  templateUrl: './item-selection.component.html',
  styleUrls: ['./item-selection.component.scss']
})
export class ItemSelectionComponent implements OnInit {
  @Input() items: any[] = [];
  @Input() textPropertyName: string;
  @Input() selectPropertyName: string;

  private startIndex: number;

  constructor() {}

  ngOnInit() {
    polyfill( {
      dragImageTranslateOverride: scrollBehaviourDragImageTranslateOverride
    } );
    
    try {
      window.addEventListener( "touchmove", function() { }, { passive: false } );
    }
    catch(e){}
  }

  onDragStart(item:any, list:any[]) {
    const index = list.indexOf(item);
    this.startIndex = index;
  }

  onDrop( event:DndDropEvent, list?:any[] ) {
    if(list && event.dropEffect === "move") {
      const prevIndex = this.startIndex;
      list.splice(prevIndex, 1);
      this.startIndex = undefined;

      let index = event.index;
      if(typeof index === "undefined") {
        index = list.length;
      }

      if(index > prevIndex) {
        index--;
      }

      list.splice(index, 0, event.data);
    }
  }
}
